module.exports = __webpack_public_path__ + "static/media/GBP.e57539d2.svg";